import { store } from '../../../redux/store'
import PageService from "../PageService";
import { dataChanged } from './pageVersionListSlice'
import ArrayUtils from "../../../utils/ArrayUtils";
import RequestQueue from "../../../utils/net/RequestQueue";

let isInitialized = false
let queue;

if (!isInitialized) {
    isInitialized = true
    queue = new RequestQueue()
    queue.subscribe({
        success: function (r) {
            const state = store.getState()
            
            if (state.pageVersionList.requestParams.offset > 0) {
                r.data.items = ArrayUtils.merge(state.pageVersionList.data.items, r.data.items, (i) => i.id)
            }

            store.dispatch(dataChanged(r.data))
        },
        error: function (r) {
            // TODO: rozwazyc powiadomienie uzytkownika o bledzie.
            console.error(r)
        },
        complete: function (r) {
            console.debug('Stream of page list request has been completed.')
        }
    })
}

const PageVersionListDataManager = {
    load: function(pageId) {
        const state = store.getState()
        queue.addRequest(PageService.findPageVersions(pageId, state.pageVersionList.requestParams))
    }
}

export default PageVersionListDataManager